module.exports = "/fonts/vendor/@fontsource/inter/files/inter-all-500-normal.woff?ce804f3f44dd988ce90a26990a5ac19c";